export default "__VITE_ASSET__e7a4d613__"